var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6497 6.58305C6.40002 7.83273 6.40002 9.84405 6.40002 13.8667V18.1334C6.40002 22.156 6.40002 24.1673 7.6497 25.417C8.89938 26.6667 10.9107 26.6667 14.9334 26.6667H17.0667C21.0893 26.6667 23.1007 26.6667 24.3503 25.417C25.6 24.1673 25.6 22.156 25.6 18.1334V13.8667C25.6 9.84405 25.6 7.83273 24.3503 6.58305C23.1007 5.33337 21.0893 5.33337 17.0667 5.33337H14.9334C10.9107 5.33337 8.89938 5.33337 7.6497 6.58305ZM10.9334 11.7334C10.9334 11.2915 11.2915 10.9334 11.7334 10.9334H20.2667C20.7085 10.9334 21.0667 11.2915 21.0667 11.7334C21.0667 12.1752 20.7085 12.5334 20.2667 12.5334H11.7334C11.2915 12.5334 10.9334 12.1752 10.9334 11.7334ZM10.9334 16C10.9334 15.5582 11.2915 15.2 11.7334 15.2H20.2667C20.7085 15.2 21.0667 15.5582 21.0667 16C21.0667 16.4419 20.7085 16.8 20.2667 16.8H11.7334C11.2915 16.8 10.9334 16.4419 10.9334 16ZM11.7334 19.4667C11.2915 19.4667 10.9334 19.8249 10.9334 20.2667C10.9334 20.7085 11.2915 21.0667 11.7334 21.0667H17.0667C17.5085 21.0667 17.8667 20.7085 17.8667 20.2667C17.8667 19.8249 17.5085 19.4667 17.0667 19.4667H11.7334Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentIcon);
export default __webpack_public_path__ + "static/media/content_icon.a16c048e16079733ca9a3991e5fc6147.svg";
export { ForwardRef as ReactComponent };